import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../common/models/Error";
import { UserState } from "../models/UserState";

const setErrorNameVendor = (state: UserState, action: PayloadAction<Error>) => {
    state.vendor.vendorNameError = action.payload.error;
}

export default setErrorNameVendor;